<template>
	<div>
		<div class="stage">
			<div class="row margin-b20">
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<back-button to="/featurecodes" />
				</div>
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<ul class="stepBtnsRight">
						<li>
							<button
								:disabled="!editFeatureCode.number || !editFeatureCode.tenant"
								class="jmiBtn btnLg green"
								@click="save()"
							>
								{{ editFeatureCode.id ? 'Save' : 'Create' }}
							</button>
						</li>
						<li><button class="jmiBtn btnLg red" @click="routeTo('/featurecodes')">Close</button></li>
					</ul>
				</div>
			</div>
			<div class="row margin-b10">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-lg-offset-3">
					<div class="row margin-b10">
						<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"></div>
					</div>
					<div class="row margin-b20">
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
							<div class="card detailCard flex flex-col rounded-sm shadow-lg">
								<div class="mx-auto mb-5 w-full">
									<div class="col-sm-12 textCenter">
										<div class="navAvatar margin-b10 flex w-full justify-center">
											<img src="/assets/images/teleflow-logo-black.png" width="200" />
										</div>
									</div>
								</div>
								<div v-if="!loading">
									<div v-if="editFeatureCode.id" class="flex w-full justify-center">
										<span class="fa-light fa-hashtag mr-2 mt-2 text-primary"></span>
										<h1>{{ editFeatureCode.number }}</h1>
									</div>
									<div class="mb-6 mt-2 border-b border-dark dark:border-light">
										<h3 class="mb-2">Feature Code</h3>
									</div>
									<div class="mx-auto mb-2 w-full px-2 md:mb-5">
										<div class="formGroup">
											<label class="textGrey">Number</label>
											<FormKit
												v-model="editFeatureCode.number"
												type="text"
												class="form-control"
												placeholder="Number"
												name="number"
											/>
										</div>
									</div>
									<div class="mx-auto mb-2 w-full px-2 md:mb-5">
										<div class="formGroup">
											<label class="textGrey">Max Duration (Minutes)</label>
											<FormKit
												v-model="editFeatureCode.maxDurationMins"
												type="text"
												class="form-control"
												placeholder="Max Duration in Minutes"
												name="maxDurationMins"
											/>
										</div>
									</div>
									<div
										v-if="
											!editFeatureCode.id &&
											(tenants?.length > 1 || $global.hasUserRole(userRoles, 'reseller'))
										"
										class="mx-auto mb-2 w-full px-2 md:mb-5"
									>
										<div class="formGroup withIcon">
											<label class="textGrey">Tenant</label>
											<select
												v-model="editFeatureCode.tenant"
												@change="editFeatureCode.account = null"
											>
												<option disabled :value="null">-- Select Tenant --</option>
												<option v-for="t in tenants" :key="t.id" :value="t">
													{{ t.companyName }}
												</option>
											</select>
											<span class="fa-light fa-chevron-down"></span>
										</div>
									</div>
									<div
										v-if="!editFeatureCode.id && editFeatureCode.tenant"
										class="mx-auto mb-2 w-full px-2 md:mb-5"
									>
										<div class="formGroup withIcon">
											<label class="textGrey">Account</label>
											<select v-model="editFeatureCode.account">
												<option :value="null">-- Unassigned - Tenant Feature Code --</option>
												<option v-for="a in tenantAccounts" :key="a.id" :value="a">
													{{ a.name }}
												</option>
											</select>
											<span class="fa-light fa-chevron-down"></span>
										</div>
									</div>
									<div class="mx-auto mb-2 w-full px-2 md:mb-5">
										<div class="formGroup">
											<label class="textGrey">Description</label>
											<input
												v-model="editFeatureCode.description"
												type="text"
												class="form-control"
												placeholder="Enter description (optional)"
											/>
										</div>
									</div>
									<application-config
										v-if="editFeatureCode.tenant"
										v-model="editFeatureCode"
										:account="editFeatureCode.account"
									/>
									<div class="margin-b20 flex px-2">
										<div class="col-md-12">
											<ul class="stepBtns">
												<li>
													<button
														:disabled="!editFeatureCode.number || !editFeatureCode.tenant"
														class="jmiBtn btnLg green"
														@click="save()"
													>
														{{ editFeatureCode.id ? 'Save' : 'Create' }}
													</button>
												</li>
												<li>
													<button class="jmiBtn btnLg red" @click="routeTo('/featurecodes')">
														Close
													</button>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div v-else>
									<div class="row margin-b20 center-xs center-md center-lg">
										<div class="loader"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import featurecodesApi from '../scripts/featurecodes/featurecodes.api.js'
import { router } from '../router/index.js'
import accountsApi from '@/scripts/accounts/accounts.api'

export default {
	inject: ['user', 'userRoles', 'tenants'],
	data() {
		return {
			editFeatureCode: {
				number: '',
				app: null,
				appConfig: {},
				maxDurationMins: '240',
				tenant: null,
				account: null,
				description: ''
			},
			loading: true,
			accounts: []
		}
	},

	computed: {
		tenantAccounts() {
			return this.accounts
				.filter((a) => a.tenant.id === this.editFeatureCode.tenant?.id)
				.sort((a, b) => a.name.localeCompare(b.name))
		}
	},

	async created() {
		try {
			accountsApi
				.getAll({ limit: 2500 })
				.then((result) => {
					this.accounts = result.data.results
				})
				.catch(console.error)

			if (this.$route.params.id !== 'new') {
				const result = await featurecodesApi.getById(this.$route.params.id)
				this.editFeatureCode = {
					...result.data,
					appConfig: result.data.appConfig || {}
				}
			} else if (this.tenants?.length === 1) {
				this.editFeatureCode.tenant = this.tenants[0]
			}
			this.loading = false
		} catch (e) {
			this.$swal({
				title: 'Error loading Feature Code',
				icon: 'error',
				confirmButtonText: 'Confirm',
				text: 'Unknown error occurred, please try again. If the issue persists, please raise a support ticket.'
			}).then(() => {
				router.push('/featurecodes')
			})
			console.error(e)
		}
	},

	methods: {
		routeTo(routeName) {
			router.push(routeName)
		},
		save() {
			if (!this.editFeatureCode.id) {
				featurecodesApi.create(this.editFeatureCode).then(this.onSave).catch(console.error)
			} else {
				featurecodesApi.update(this.editFeatureCode).then(this.onSave).catch(console.error)
			}
		},
		onSave(result) {
			if (result.success === false) {
				if (result.error === 'Duplicate entry') {
					this.$swal({
						title: 'Duplicate Number',
						icon: 'error',
						confirmButtonText: 'Try Again',
						text: 'This number is already in use. Please choose another.'
					})
				} else {
					this.$swal({
						title: 'Error Occurred',
						icon: 'error',
						confirmButtonText: 'Try Again',
						text: 'Unknown error occurred, please try again or contact support.'
					})
				}
			} else this.routeTo('/featurecodes')
		}
	}
}
</script>
